// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "footer__scrollBody-260rW";
var _4 = "closeIcon-3I8vx";
var _5 = "footer__slideBottom-1OTRs";
var _6 = "social-1lWrf";
export { _1 as "__esModule", _2 as "mobile", _3 as "footer__scrollBody", _4 as "closeIcon", _5 as "footer__slideBottom", _6 as "social" }
export default { "__esModule": _1, "mobile": _2, "footer__scrollBody": _3, "closeIcon": _4, "footer__slideBottom": _5, "social": _6 }
